import type { Table } from '@tanstack/react-table';
import { useState } from 'react';
import Input, { type InputProps } from '../forms/Input';

interface Props extends Omit<InputProps, 'label'> {
  table: Table<any>;
  label?: string;
  onFilterChange?: (value: string) => void;
}

export default function GlobalFilter({
  table,
  placeholder = 'Search...',
  label = '',
  onFilterChange,
  ...props
}: Props) {
  const [filterValue, setFilterValue] = useState<string>('');

  const onChange = (value: string) => {
    setFilterValue(value);
    table.setGlobalFilter(value);
    onFilterChange?.(value);
  };

  return <Input {...props} value={filterValue} placeholder={placeholder} label={label} onChange={onChange} />;
}
